import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th"
dayjs.extend(buddhistEra);

const getYearFormat = (locale) => {
  return locale === 'th' ? 'BB' : 'YY'
}

export const formatDateTime = (datetime, locale = 'th') => {
  const yearFormat = getYearFormat(locale);
  if (!datetime) return dayjs().locale(locale).format(`D MMM ${yearFormat}`);
  return dayjs(datetime).locale(locale).format(`D MMM ${yearFormat}`);
};

export const formatDateTimeLocale = (datetime, locale = 'th') => {
  if(locale == "th")
    return dayjs(datetime).locale(locale).format("D MMM BBBB");
  else if(locale == "en")
    return dayjs(datetime).locale(locale).format("D MMM YYYY");
};

export const formatFullDateLocale = (datetime, locale = 'th') => {
  if(locale == "th")
    return dayjs(datetime).locale(locale).format("D MMMM BBBB");
  else if(locale == "en")
    return dayjs(datetime).locale(locale).format("D MMMM YYYY");
};

export const formatFullDateTimeTH = (datetime) => {
  return dayjs(datetime).locale("th").format("วันddd D MMM BB");
};

export const formatDateTimeTH = (datetime) => {
  return dayjs(datetime).locale("th").format("D MMM BB");
};

export const formatDay = (datetime) => {
  return dayjs(datetime).locale("th").format("dddd");
};

export const formatMonth = (datetime) => {
  return dayjs(datetime).locale("th").format("MMMM");
};

export const formatTime = (datetime, prefix = '', suffix = '') => {
  return dayjs(datetime).locale("th").format(`${prefix} HH : mm ${suffix}`);
};

export const toBuddhistYear = (year, empty = '') => {
  if (!year) return empty;
  return parseInt(year) + 543;
}

export const dateTime = () => {
  return dayjs().format();
}

export const dateTimeFormat = (datetime,format = "YYYY-MM-DD") => {
  return dayjs(datetime).format(format);
}

export const dateTimeLocale = (format = "YYYY-MM-DD HH:mm:ss", locale = "th") => {
  return dayjs().locale(locale).format(format);
}

export const isBeforeTime = (start, end) => {
  return dayjs(`2011-01-01 ${end}:00`).valueOf() <= dayjs(`2011-01-01 ${start}:00`).valueOf();
}
